// @ts-ignore
const isExplorer = () => !!window.MSInputMethodContext && !!document.documentMode;
export default isExplorer;
